export const CommonCodes = [

  /* MEMBER_STATUS */
  { group: "MEMBER_STATUS",  comdCode: "A", comdName: "승인대기" },
  { group: "MEMBER_STATUS",  comdCode: "B", comdName: "정상"     },
  { group: "MEMBER_STATUS",  comdCode: "C", comdName: "휴면"     },
  { group: "MEMBER_STATUS",  comdCode: "D", comdName: "정지"     },
  { group: "MEMBER_STATUS",  comdCode: "E", comdName: "삭제"     },

  /* LECTURE_STATUS */
  { group: "LECTURE_STATUS",  comdCode: "A", comdName: "개강전" },
  { group: "LECTURE_STATUS",  comdCode: "B", comdName: "신청마감"     },
  { group: "LECTURE_STATUS",  comdCode: "C", comdName: "진행"     },
  { group: "LECTURE_STATUS",  comdCode: "D", comdName: "종강"     },

  /* EDU_TYPE */
  { group: "EDU_TYPE",  comdCode: "A", comdName: "출강" },
  { group: "EDU_TYPE",  comdCode: "B", comdName: "집체(대면)"     },
  { group: "EDU_TYPE",  comdCode: "C", comdName: "집체(비대면)"     },
  { group: "EDU_TYPE",  comdCode: "D", comdName: "집체(영상)"     },
  { group: "EDU_TYPE",  comdCode: "E", comdName: "집체(혼합)"     },

  /* EDU_DT_CD */
  { group: "EDU_DT_CD",  comdCode: "A", comdName: "이틀"     },
  { group: "EDU_DT_CD",  comdCode: "F", comdName: "첫날"     },
  { group: "EDU_DT_CD",  comdCode: "S", comdName: "둘째날"     },

  /* APPLY_STATUS */
  { group: "APPLY_STATUS",  comdCode: "A", comdName: "승인대기" },
  { group: "APPLY_STATUS",  comdCode: "B", comdName: "승인"     },
  { group: "APPLY_STATUS",  comdCode: "C", comdName: "승인취소"     },
  { group: "APPLY_STATUS",  comdCode: "N", comdName: "신청취소"     },
  { group: "APPLY_STATUS",  comdCode: "R", comdName: "반려"     },

  /* ROLE */
  { group: "ROLE",  comdCode: "R0", comdName: "관리자" },
  { group: "ROLE",  comdCode: "R2", comdName: "수강생"     },

];

/** 원하는 그룹 을 받아 옵션 배열을 돌려준다 */
export function getOptions(group) {
  return CommonCodes.filter((c) => c.group === group);
}

/** 코드값 으로 한글명을 찾고 싶을 때 */
export function getNameByCode(group, comdCode) {
  const found = CommonCodes.find(
    (c) => c.group === group && c.comdCode === comdCode
  );
  return found ? found.comdName : "";
}

/** 한글명으로 코드값 찾고 싶을 때 */
export const getCodeByName = (group, comdName) => {
  const found = CommonCodes.find(
    (c) => c.group === group && c.comdName === comdName
  );
  return found ? found.comdCode : undefined;      // 없으면 undefined
};